import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-search" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "group"
}
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "search" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "type" }
const _hoisted_14 = {
  key: 0,
  class: "empty"
}

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { svgIcon, baseInput } from "@/common/components";

import { methodGroupList } from "@/common/api/rest/method/method-group";
import { methodItemList } from "@/common/api/rest/method/method-item";

import type { MethodGroupType } from "@/common/types/method/method-group";
import type { MethodItemType } from "@/common/types/method/method-item";


export default /*@__PURE__*/_defineComponent({
  __name: 'method-item',
  props: {
    title: {},
    accountId: {},
    categoryId: {},
    ids: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const inputSearch = ref<string | null>("");
const groups = ref<MethodGroupType[]>([]);
const methods = ref<MethodItemType[]>([]);

const selectedGroupId = ref<string | null>(null);
const selectedMethod = ref<MethodItemType | null>(null);

function fetchCategory() {
  if (!props.accountId) return;
  methodGroupList(props.accountId, {
    all: true,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        groups.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function search() {
  if (!props.accountId || !selectedGroupId.value) return;

  methodItemList(props.accountId, selectedGroupId.value, {
    search: inputSearch.value as string,
    all: true,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        methods.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function selectGroup(data: MethodGroupType) {
  selectedGroupId.value = data.group_id;
  search();
}

function selectMethod(data: MethodItemType) {
  if (props.ids?.includes(data.method_id)) return;

  selectedMethod.value = data;
  emit("update-data", data);
}

onMounted(() => {
  if (!props.categoryId) fetchCategory();
  else selectedGroupId.value = props.categoryId;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    (!selectedGroupId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "Selecione o Grupo de Métodos:", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.group_id,
                class: "item",
                onClick: ($event: any) => (selectGroup(item))
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1)
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(baseInput), {
              modelValue: inputSearch.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
              background: "#fff",
              color: "#000",
              placeholder: _unref(t)('common.labels.search'),
              "onKey:enter": _cache[2] || (_cache[2] = ($event: any) => (search()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (search()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(methods.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["item", {
              active: selectedMethod.value?.method_id === item.method_id,
              disabled: props.ids?.includes(item.method_id),
            }]),
                onClick: ($event: any) => (selectMethod(item))
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.code), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)
              ], 10, _hoisted_11))
            }), 128)),
            (methods.value?.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
              : _createCommentVNode("", true)
          ])
        ], 64))
  ]))
}
}

})